import { API_ROUTES } from "../utils/constants";
import http from "../config/httpConfig";

const save = async (patient: {}) => {
    return http.post(API_ROUTES.PATIENT_POST, patient);
};

const edit = async (patient: {}) => {
    return http.post(API_ROUTES.PATIENT_EDIT, patient);
};

const findById = async (id: any) => {
    return http.get(API_ROUTES.PATIENT_GET + id);
};

const findAll = async () => {
    return await http.get(API_ROUTES.PATIENT_ALL);
};

const deleteById = async (id: bigint) => {
    console.log(id);
    return http.delete(`${API_ROUTES.PATIENT_DELETE}${id}`);
};

const findAllByAllColumn = async (data: { pageNumber: number, pageSize: number, text: string }) => {
    return http.post(API_ROUTES.PATIENT_ADVANCE_SEARCH, data);
};

const uploadProfile = async (image64: String) => {
    return http.post(API_ROUTES.PATIENT_UPLOAD_PROFILE, { fileContentBase64: image64 });
};
const uploadFinger = async (finger: any) => {
    return http.post(API_ROUTES.PATIENT_UPLOAD_FINGER, finger);
};

const findByProfile = async (id: any) => {
    return http.get(API_ROUTES.PATIENT_PROFILE_GET.replace(':id', id));
};

const uploadProfileById = async (id: any, image64: String) => {
    return http.post(API_ROUTES.PATIENT_UPLOAD_PROFILE_BY_ID.replace(':id', id), { fileContentBase64: image64 });
};

const uploadXrayById = async (id: any, image64: String) => {
    return http.post(API_ROUTES.PATIENT_UPLOAD_XRAY_BY_ID.replace(':id', id), { fileContentBase64: image64 });
};

const massUploadXray = async (files: File[]) => {
    const formData = new FormData();
    for (let i = 0; i < files.length; i++) {
        formData.append('files', files[i], files[i].webkitRelativePath);
    }
    try {
        return http.post(API_ROUTES.PATIENT_MASS_UPLOAD_XRAY, formData);
    } catch (error) {
        console.error("Error uploading files:", error);
        throw error;
    }
};

const uploadFingerById = async (id: any, image64: String) => {
    return http.post(API_ROUTES.PATIENT_UPLOAD_FINGER_BY_ID.replace(':id', id), { fileContentBase64: image64 });
};
const search = async (text: string) => {
    return http.get(API_ROUTES.PATIENT_SEARCH.replace(':query', text));
};

const findByPassport = async (passport: string) => {
    return http.get(API_ROUTES.PATIENT_BY_PASSPORT.replace(':passport', passport));
};

const updateStatus = async (patient: {}) => {
    return http.post(API_ROUTES.PATIENT_UPDATE_STATUS, patient);
};
const updateReport = async (patient: { id: number, ColumnName: string, value: string }) => {
    return http.put(API_ROUTES.PATIENT_REPORT_VALUES_PUT, patient);
};

const findReportResultOfMachine = async (id: any) => {
    return http.get(API_ROUTES.PATIENT_REPORT_BY_MACHINE.replace(':id', id));
};
const PatientService = {
    save,
    edit,
    uploadProfileById,
    uploadFingerById,
    findByProfile,
    findById,
    findAll,
    search,
    deleteById,
    findAllByAllColumn,
    uploadProfile,
    uploadFinger,
    uploadXrayById,
    findByPassport,
    updateStatus,
    updateReport,
    massUploadXray,
    findReportResultOfMachine
}
export default PatientService;
